import React, { useEffect, useState } from 'react'
import styles from '../ChallengeSteps/challengeSteps.module.scss'
import cx from 'classnames'
import CancelBtn from '../../../../icons/cancelBtn.svg'
import AcceptBtn from '../../../../icons/acceptBtn.svg'
import Download from '../../../../icons/download.svg'
import Edit from '../../../../icons/edit.svg'
import TypingEffect from '../TypingEffect'
import { useDispatch, useSelector } from 'react-redux'
import { setConfirmationModal } from '../../../../redux/actions/confirmationModal'
import AuthModalComponent from '../NestedComponentOfModal/AuthModalComponent'
import { setToastNotification } from '../../../../redux/actions/toastNotification'
// import TypingEffect from "../TypingEffect";

const AuthChallenge = ({
  quizAuth,
  notAuthAnsweredIndex,
  editList,
  setEdit,
  getTextValue,
  handleAuthTextAnswer,
  edit,
  handleEdit,
  handleCancel,
  messageRefs,
}) => {
  const {
    quizQuestions: { editSummary, index, groupName },
  } = useSelector((state) => state)
  // const { phoneNumberObj } = useSelector((state) => state.auth)
  const {
    privateIndividual: { indexPrivate },
    commerciallyActive: { indexActive },
  } = useSelector((state) => state.quizQuestions)
  const dispatch = useDispatch()
  const [disabled, setDisabled] = useState(false)
  useEffect(() => {
    quizAuth.map((item, i) => {
      if (!!item.edit && index === i) {
        ;(item.type === 'birthDay' ||
          item.type === 'date' ||
          item.type === 'option' ||
          item.type === 'submit' ||
          item.type === 'phoneNumber') &&
          handleModalAuth(item, i)
      }
    })
  }, [groupName])
  const handleModalAuth = (item, i) => {
    dispatch(
      setConfirmationModal({
        headerText: 'Edit',
        body: (
          <AuthModalComponent
            item={item}
            authIndex={i}
            indexPrivate={indexPrivate}
            indexActive={indexActive}
          />
        ),
        large: true,
      }),
    )
  }
  return (
    <>
      {quizAuth?.slice(0, notAuthAnsweredIndex + 1).map((item, i) => {
        return (
          <>
            <li
              className={styles.odd}
              ref={(el) => (messageRefs.current['authorizedPerson' + i] = el)}
            >
              <img src={item?.img} alt={item?.img} />
              <p>
                {item?.answers ? (
                  item.question
                ) : (
                  <TypingEffect text={item?.question} speed={50} />
                )}
              </p>
            </li>
            {item?.answers && (
              <li
                className={cx(styles.even, {
                  [styles.fileStyle]: item?.type === 'file',
                  [styles.hideList]: editList !== 1,
                  [styles.borderLi]:
                    !!item.edit && (item.type === 'text' || item.type === 'number'),
                })}
                onMouseOver={() => setEdit(i)}
                onMouseOut={() => setEdit(-1)}
              >
                {!!item.edit && (item.type === 'text' || item.type === 'number') ? (
                  <>
                    <textarea
                      maxLength={`${item.type === 'number' && 5}`}
                      onChange={(e) => {
                        item.type === 'number' &&
                        !/^\d*$/.test(e.currentTarget.value) &&
                        e.currentTarget.value.length <= 5
                          ? setDisabled(true)
                          : Number(e.currentTarget.value) &&
                              e.currentTarget.value.length !== 5 &&
                              item?.questionKey === 'zipCode'
                            ? setDisabled(true)
                            : setDisabled(false)
                        item.type === 'number' && !Number(e.currentTarget.value)
                          ? dispatch(
                              setToastNotification({
                                type: 'robotik',
                                toastBody:
                                  'Ups! Hier muss noch etwas korrigiert werden. In diesem Feld können nur Zahlen eingetragen werden.',
                              }),
                            )
                          : getTextValue(e)
                      }}
                      autoFocus={true}
                    >
                      {item?.answers.trim()}
                    </textarea>
                    <div>
                      <img
                        src={CancelBtn}
                        alt={CancelBtn}
                        onClick={() => handleCancel(i)}
                      />
                      <img
                        src={AcceptBtn}
                        alt={AcceptBtn}
                        onClick={() => {
                          !disabled && handleAuthTextAnswer(i)
                        }}
                        className={cx({ [styles.disabledImg]: disabled })}
                      />
                    </div>
                  </>
                ) : (
                  <p>
                    {/*{item.type === 'phoneNumber' &&  authorizedPerson.phoneNumber !== '-' ? `+${phoneNumberObj.callingCode} `+``+`${item?.answers}` : item?.answers}*/}
                    {/*{item.type === 'phoneNumber' &&   item?.answers}*/}
                    {item?.answers}
                    {item?.type === 'file' && <img src={Download} alt={Download} />}
                    {edit === i && !editSummary && (
                      <img
                        src={Edit}
                        alt={Edit}
                        onClick={() =>
                          item.type === 'birthDay' ||
                          item.type === 'date' ||
                          item.type === 'option' ||
                          item.type === 'submit' ||
                          item.type === 'phoneNumber'
                            ? handleModalAuth(item, i)
                            : handleEdit(i)
                        }
                      />
                    )}
                  </p>
                )}
              </li>
            )}
            {item?.returnQuestion && (
              <div className={styles.returnQuestion}>
                {/*<img src={item?.img} alt={item?.img}/>*/}
                <p>{item?.returnQuestion}</p>
              </div>
            )}
            {(item?.answers === 'Ja' || item.answers === 'Unter 6 monate') &&
              item?.returnLink && (
                <div className={styles.returnLink}>
                  <a href={item?.returnLink} target="_blank" rel="noreferrer">
                    {'Mehr erfahren'}
                  </a>
                </div>
              )}
          </>
        )
      })}
    </>
  )
}
export default AuthChallenge
